"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ApprovalPathStepActionKind;

(function (ApprovalPathStepActionKind) {
  ApprovalPathStepActionKind[ApprovalPathStepActionKind["Approve"] = 0] = "Approve";
  ApprovalPathStepActionKind[ApprovalPathStepActionKind["Reject"] = 1] = "Reject";
})(ApprovalPathStepActionKind = exports.ApprovalPathStepActionKind || (exports.ApprovalPathStepActionKind = {}));

var ApprovalStatus;

(function (ApprovalStatus) {
  ApprovalStatus[ApprovalStatus["InProgress"] = 0] = "InProgress";
  ApprovalStatus[ApprovalStatus["Approved"] = 1] = "Approved";
  ApprovalStatus[ApprovalStatus["Rejected"] = 2] = "Rejected";
  ApprovalStatus[ApprovalStatus["Skipped"] = 3] = "Skipped";
})(ApprovalStatus = exports.ApprovalStatus || (exports.ApprovalStatus = {}));

var ShiftSearchType;

(function (ShiftSearchType) {
  ShiftSearchType[ShiftSearchType["All"] = 0] = "All";
  ShiftSearchType[ShiftSearchType["Filled"] = 1] = "Filled";
  ShiftSearchType[ShiftSearchType["UnFilled"] = 2] = "UnFilled";
  ShiftSearchType[ShiftSearchType["Cancelled"] = 3] = "Cancelled";
})(ShiftSearchType = exports.ShiftSearchType || (exports.ShiftSearchType = {}));

var MatchActivityStatus;

(function (MatchActivityStatus) {
  MatchActivityStatus[MatchActivityStatus["PendingStart"] = 0] = "PendingStart";
  MatchActivityStatus[MatchActivityStatus["EndingSoon"] = 1] = "EndingSoon";
  MatchActivityStatus[MatchActivityStatus["Ended"] = 2] = "Ended";
})(MatchActivityStatus = exports.MatchActivityStatus || (exports.MatchActivityStatus = {}));

var MatchSearchType;

(function (MatchSearchType) {
  MatchSearchType[MatchSearchType["All"] = 0] = "All";
  MatchSearchType[MatchSearchType["Submittals"] = 1] = "Submittals";
  MatchSearchType[MatchSearchType["PendingStart"] = 2] = "PendingStart";
  MatchSearchType[MatchSearchType["Working"] = 3] = "Working";
  MatchSearchType[MatchSearchType["EndingSoon"] = 4] = "EndingSoon";
  MatchSearchType[MatchSearchType["Ended"] = 5] = "Ended";
  MatchSearchType[MatchSearchType["PendingMyApproval"] = 6] = "PendingMyApproval";
})(MatchSearchType = exports.MatchSearchType || (exports.MatchSearchType = {}));

var MatchActionType;

(function (MatchActionType) {
  MatchActionType[MatchActionType["MakeOffer"] = 0] = "MakeOffer";
  MatchActionType[MatchActionType["InviteForInterview"] = 1] = "InviteForInterview";
  MatchActionType[MatchActionType["Reject"] = 2] = "Reject";
})(MatchActionType = exports.MatchActionType || (exports.MatchActionType = {}));

var MatchStatusType;

(function (MatchStatusType) {
  MatchStatusType[MatchStatusType["RejectionRequested"] = 0] = "RejectionRequested";
  MatchStatusType[MatchStatusType["Rejected"] = 1] = "Rejected";
  MatchStatusType[MatchStatusType["Matched"] = 2] = "Matched";
  MatchStatusType[MatchStatusType["Present"] = 3] = "Present";
  MatchStatusType[MatchStatusType["Submittal"] = 4] = "Submittal";
  MatchStatusType[MatchStatusType["Invited"] = 5] = "Invited";
  MatchStatusType[MatchStatusType["InterviewRequested"] = 6] = "InterviewRequested";
  MatchStatusType[MatchStatusType["FirstRoundInterview"] = 7] = "FirstRoundInterview";
  MatchStatusType[MatchStatusType["PastFirstInterview"] = 8] = "PastFirstInterview";
  MatchStatusType[MatchStatusType["InterviewsComplete"] = 9] = "InterviewsComplete";
  MatchStatusType[MatchStatusType["MakeOfferRequested"] = 10] = "MakeOfferRequested";
  MatchStatusType[MatchStatusType["OfferWillBeMade"] = 11] = "OfferWillBeMade";
  MatchStatusType[MatchStatusType["OfferMade"] = 12] = "OfferMade";
  MatchStatusType[MatchStatusType["CandidateAccepted"] = 13] = "CandidateAccepted";
  MatchStatusType[MatchStatusType["FallOff"] = 14] = "FallOff";
  MatchStatusType[MatchStatusType["PartialPlacement"] = 15] = "PartialPlacement";
  MatchStatusType[MatchStatusType["FullPlacement"] = 16] = "FullPlacement";
  MatchStatusType[MatchStatusType["Converted"] = 17] = "Converted";
})(MatchStatusType = exports.MatchStatusType || (exports.MatchStatusType = {}));

var BasePositionStatus;

(function (BasePositionStatus) {
  BasePositionStatus[BasePositionStatus["Closed"] = 0] = "Closed";
  BasePositionStatus[BasePositionStatus["OnHold"] = 1] = "OnHold";
  BasePositionStatus[BasePositionStatus["Open"] = 2] = "Open";
})(BasePositionStatus = exports.BasePositionStatus || (exports.BasePositionStatus = {}));

var PositionSearchType;

(function (PositionSearchType) {
  PositionSearchType[PositionSearchType["All"] = 0] = "All";
  PositionSearchType[PositionSearchType["Open"] = 1] = "Open";
  PositionSearchType[PositionSearchType["Closed"] = 2] = "Closed";
  PositionSearchType[PositionSearchType["PendingMyApproval"] = 3] = "PendingMyApproval";
})(PositionSearchType = exports.PositionSearchType || (exports.PositionSearchType = {}));